export default __webpack_public_path__ + "static/media/grafema_ummi_05.101b8fcb.jpg";